import { lazy } from 'react'

const Configurations = lazy(() => import('../../views/configurations'))

const ConfigurationRoutes = [
  {
    element: <Configurations />,
    path: '/configurations',
    meta: { action: 'manage', resource: 'all' }
  }
]

export default ConfigurationRoutes
